var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.notifications, function(notification, index) {
      return _c(
        "sc-modal",
        {
          key: index,
          attrs: { active: !notification.isReaded, canCancel: false },
          on: {
            "update:active": function($event) {
              _vm.$set(!notification, "isReaded", $event)
            }
          }
        },
        [
          _c(
            "sc-modal-card",
            [
              _c("template", { attrs: { slot: "title" }, slot: "title" }, [
                _c(
                  "h2",
                  {
                    staticClass: "modal-card-title notification-title",
                    class:
                      "notification-title--" +
                      _vm.getClassPerType(notification.type)
                  },
                  [_vm._v(_vm._s(notification.title))]
                )
              ]),
              _vm._v(" "),
              _c("template", { attrs: { slot: "body" }, slot: "body" }, [
                _c("section", { staticClass: "content" }, [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(notification.message) }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary",
                        attrs: { href: notification.link, target: "_blank" }
                      },
                      [
                        _vm._v(
                          "\n              Visualizar nota fiscal\n            "
                        )
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "template",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  notification.type === _vm.types.INFO
                    ? _c("sc-button", {
                        attrs: {
                          type: "button",
                          text: "Ok, obrigado!",
                          loading: _vm.loading,
                          theme: _vm.getClassPerType(notification.type)
                        },
                        on: {
                          click: function($event) {
                            _vm.closeNotification(notification)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  notification.type === _vm.types.WARNING
                    ? _c("sc-button", {
                        attrs: {
                          type: "button",
                          text: "Estou ciente",
                          loading: _vm.loading,
                          theme: _vm.getClassPerType(notification.type)
                        },
                        on: {
                          click: function($event) {
                            _vm.closeNotification(notification)
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  notification.type === _vm.types.DANGER
                    ? _c("sc-button", {
                        attrs: {
                          type: "button",
                          text: "Sair",
                          loading: _vm.loading,
                          theme: _vm.getClassPerType(notification.type)
                        },
                        on: {
                          click: function($event) {
                            _vm.closeNotification(notification)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25b082c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b082c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/sc-notification/ScNotification.vue
// module id = null
// module chunks = 